namespace GeniuzPOS.ReportMasterData {
    export class Report_1408Columns {
        static columnsKey = 'ReportMasterData.Report_1408';
    }
}
